<template>
  <v-container class="white black--text" id="comment-container">
    <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->
    <v-form ref="form">
      <div class="header d-flex flex-column align-center">
        <div id="commentId" style="display: none">[form.first_name]</div>
        <p class="mb-0">Reno Police Department Compliment Form</p>
        <p class="blue--text" style="font-size: 1em">
          Reno Police Department Formulario de Cumplido
        </p>
      </div>

      <!-- intro -->
      <div class="intro">
        <p>
          Thank you for expressing interest in the Reno Police Department. We
          are very concerned that our citizens receive the best law enforcement
          possible and value your Compliments. Anything you tell us here will be
          provided directly to the Chief of Police for appropriate action.
        </p>
        <p class="blue--text">
          Gracias por expresar interés en el Departamento de Policía de Reno.
          Nosotros Estamos muy preocupados de que nuestros ciudadanos reciban la
          mejor aplicación de la ley posible y valoramos sus elogios. Cualquier
          cosa que nos digas aquí se proporcionará directamente al Jefe de
          Policía para su correspondiente acción.
        </p>
      </div>

      <!-- Instructions -->
      <div class="inst-list">
        <span>Instructions/</span>
        <span class="blue--text">Instrucciones:</span>

        <ol>
          <li>
            <p class="mb-0">Please be clear and specific.</p>
            <p class="blue--text">Por favor sea claro y específico.</p>
          </li>
          <li>
            <p class="mb-0">Only the Nature of the compliment is required</p>
            <p class="blue--text">Sólo se requiere la naturaleza del elogio.</p>
          </li>

          <li>
            <p class="mb-0">
              Click/Tap the Submit Button to submit the form to the RPD.
            </p>

            <p class="blue--text">
              Haga clic o toque el botón Enviar para enviar el formulario al
              RPD.
            </p>
          </li>
          <li>
            <p class="mb-0">
              Click/Tap the Print Button to print the form for your records.
            </p>
            <p style="font-size: small">
              (Print button will appear after you submit)
            </p>
            <p class="blue--text mb-0">
              Haga clic o toque el botón Imprimir para imprimir el formulario
              para sus registros.
            </p>
            <p class="blue--text" style="font-size: small">
              (El botón Imprimir aparecerá después de enviar)
            </p>
          </li>
          <li>
            <p class="mb-0">
              If you supply an email, a copy of the submitted form will be
              emailed to you.
            </p>

            <p class="blue--text mb-0">
              Si proporciona un correo electrónico, se le enviará una copia del
              formulario enviado.
            </p>
          </li>
        </ol>
      </div>
      <hr />
      <br />

      <!-- CITIZEN INFORMATION -->
      <v-expansion-panels multiple v-model="panel" class="citizen-info-coll">
        <v-expansion-panel popout class="mt-2" width="100%">
          <v-expansion-panel-header color="#708e92" class="white--text">
            <template v-slot:actions>
              <v-icon color="white"> $expand </v-icon>
            </template>
            <p class="mb-0">
              CITIZEN INFORMATION <br /><br />INFORMACIÓN DEL CIUDADANO
            </p>
          </v-expansion-panel-header>
          <v-expansion-panel-content id="content1" class="grey lighten-5">
            <v-container>
              <v-row>
                <v-col cols="12" md="6" lg="6">
                  <v-text-field
                    id="last_name"
                    name="last_name"
                    maxlength="60"
                    v-model="form.last_name"
                    label="Last Name/Apellido"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" lg="6">
                  <v-text-field
                    id="first_name"
                    name="first_name"
                    maxlength="60"
                    v-model="form.first_name"
                    label="First Name/Primer Nombre"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" lg="6">
                  <v-text-field
                    id="mi"
                    name="mi"
                    maxlength="1"
                    v-model="form.mi"
                    label="Middle Initial/Inicial del Segundo Nombre "
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="6" lg="6">
                  <v-text-field
                    id="home_phn"
                    name="home_phn"
                    maxlength="12"
                    v-model="form.phone"
                    label="Home Phone/Teléfono de la Casa"
                    v-mask="'###-###-####'"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="6" lg="6">
                  <v-text-field
                    id="email"
                    name="email"
                    maxlength="120"
                    v-model="form.email"
                    label="Email/Correo Electrónico"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12" lg="12">
                  <div class="fake-coll px-4 d-flex align-center">
                    <label class="white--text"
                      >Nature of the compliment <br />Naturaleza del
                      cumplido</label
                    >
                  </div>
                  <v-textarea
                    class="mt-2"
                    solo
                    aria-required="true"
                    required
                    :rules="[rules.required]"
                    id="narrative"
                    name="narrative"
                    maxlength="4000"
                    v-model="form.narrative"
                  ></v-textarea>
                  <!-- label="NATURE OF COMPLAINT/ NATURALEZA DE LA
                    QUEJA/COMENTARIO" -->
                </v-col>
              </v-row>
            </v-container>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-form>

    <div class="print-sub-buttons d-flex justify-space-around">
      <v-btn v-if="form.commentId > 0" color="accent" @click="print"
        >Print</v-btn
      >
      <v-btn v-if="form.commentId == 0" color="accent" @click="submit"
        >Submit</v-btn
      >
      <v-btn v-if="form.commentId > 0" color="accent" @click="close"
        >Close</v-btn
      >
    </div>
  </v-container>
</template>

<!-- style -->
<style lang="scss" scoped>
@import "../scss/site.scss";
#comment-container {
  max-width: 768px;
}

/* 0 media q */
@media (min-width: 0px) {
  .header p {
    font-size: 1.2em;
  }

  .witness-info hr {
    width: 100%;
  }

  .fake-coll {
    width: 100%;
    background-color: #708e92;
    font-size: 0.937rem;
    height: 66px;
  }
}

/* 320 media q */
/* smartphones, iPhone, portrait 480x320 phones */
@media (min-width: 320px) {
}

/* 641 media q */
/* portrait tablets, portrait iPad, landscape e-readers, landscape 800x480 or 854x480 phones */
@media (min-width: 641px) {
  .header p {
    font-size: 1.75em;
  }
}

/* 768 media q */
@media (min-width: 768px) {
}

/* 961 media q */
/* tablet, landscape iPad, lo-res laptops ands desktops */
@media (min-width: 961px) {
}

/* ipad lansdscape */
/* tablet, landscape iPad, lo-res laptops ands desktops */
@media (min-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
}

/* 1025 media q */
/* big landscape tablets, laptops, and desktops */
@media (min-width: 1025px) {
  .header p {
    font-size: 2em;
  }
}

/* 1281 media q */
/* hi-res laptops and desktops */
@media (min-width: 1281px) {
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<!-- Script -->
<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
export default {
  name: "comment",
  mixins: [bus_common],
  data() {
    return {
      rules: {
        required: (value) => !!value || "This Field is Required.",
        namelength60: (value) => value.length <= 60 || "Max 60 characters",
        namelength1: (value) => value.length <= 1 || "Max 1 characters",
        namelength5: (value) => value.length == 5 || "Must be 5 characters",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
      panel: [0],
      new_form_dev: {
        commentId: 0,
        last_name: "last_name", //60
        first_name: "first_name", //60
        mi: "m", //1

        phone: "7755555555", //12
        email: "jvonmolt@gmail.com", //120
        case_num: "99-99999",
        location: "round the corner",
        narrative: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Maxime mollitia,
molestiae quas vel sint commodi repudiandae consequuntur voluptatum laborum
numquam blanditiis harum quisquam eius sed odit fugiat iusto fuga praesentium
optio, eaque rerum! Provident similique accusantium nemo autem. Veritatis
obcaecati tenetur iure eius earum ut molestias architecto voluptate aliquam
nihil, eveniet aliquid culpa officia aut! Impedit sit sunt quaerat, odit,
tenetur error, harum nesciunt ipsum debitis quas aliquid. Reprehenderit,
quia. Quo neque error repudiandae fuga? Ipsa laudantium molestias eos 
sapiente officiis modi at sunt excepturi expedita sint? Sed quibusdam
recusandae alias error harum maxime adipisci amet laborum. Perspiciatis 
minima nesciunt dolorem! Officiis iure rerum voluptates a cumque velit `, //8000
      },
      new_form: {
        commentId: 0,
        last_name: "",
        first_name: "",
        mi: "",

        phone: "",
        email: "",
        case_num: "",
        location: "",
        narrative: "", //8000
      },
      form: {
        commentId: 0,
        last_name: "",
        first_name: "",
        mi: "",

        phone: "",
        email: "",
        case_num: "",
        location: "",
        narrative: "", //8000
      },
    };
  },
  methods: {
    message1() {
      alert("This button does nothing yet.");
    },
    close() {
      this.$router.push("/");
    },
    print() {
      let rnd1 = this.randomNum(1000, 9999);
      let rnd2 = this.randomNum(1000, 9999);
      let id = parseInt(
        rnd1.toString() + this.form.commentId.toString() + rnd2.toString()
      );
      console.log(this.form.commentId, id);
      window.open("/printform/print_comm/?id=" + id);
    },
    submit() {
      //   this.mrbreakpoint("compliment");

      if (this.$refs.form.validate() == false) {
        this.show_loader(false);
        this.swall_it(
          "Form Status",
          "Please fix the red marked fields.",
          "warning",
          null,
          null
        );
        return true;
      }
      this.show_loader(true);
      var formIn = this.mno(this.form);

      formIn.apiname = "save_comment";

      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          this.show_loader(false);
          self.form = self.mno(data);

          self.form.narrative = self.replaceBrWithLineBreaks(
            self.form.narrative
          );
          this.swall_it(
            "Thank You",
            "Thank you for submitting your compliment form to the Internal Affairs office. We will pass along the compliment to the respective employee and/or department. Have a good day! <br> You may close this page or Print a Copy.<br><br>Gracias por enviar su formulario de felicitación a la oficina de Asuntos Internos. Transmitiremos la felicitación al empleado y/o departamento correspondiente. ¡Que tenga un buen día! <br> Puede cerrar esta página o Imprimir una copia.",
            "success",
            null,
            null
          );
          // this.$router.push("/");
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error", msg.msg, "error", null, null);
        });
    },
    init() {
      document.getElementById("vapp").style.overflowY = "scroll";
      this.form = this.mno(this.new_form);
      this.show_loader(false);
    },
  },
  mounted() {
    console.log("routed to comment");
    this.$nextTick(() => {
      this.init();
    });
    // track page visits/
    console.log("banner mounted");
    // Build the payload
    const payload = {
      url: window.location.href,
      referrer: document.referrer,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
    };

    console.log("track: " + payload.url);

    // Post to your analytics endpoint
    fetch("/Analytics/Track", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    }).catch((err) => {
      console.error("Analytics tracking failed:", err);
    });
  },
};
</script>
